/**
 * Kurze Rückmeldung am unteren Bildschirmrand.
 *
 * Derselbe Block lag bisher in mehreren Seiten identisch kopiert. Neue Seiten
 * importieren ihn von hier; die bestehenden Kopien bleiben vorerst, damit diese
 * Änderung keine unbeteiligten Dateien anfasst.
 */
export function showToast(message: string): void {
  const toast = document.createElement("div");
  toast.className = "toast";
  toast.textContent = message;
  document.body.appendChild(toast);
  requestAnimationFrame(() => toast.classList.add("toast--visible"));
  setTimeout(() => {
    toast.classList.remove("toast--visible");
    setTimeout(() => toast.remove(), 300);
  }, 2500);
}
